import { useCallback, useEffect, useRef } from 'react';

// Generated photos and videos are served from a private bucket through signed URLs, and those
// expire (a day after they are signed). A page left open that long is still holding the old ones,
// and an expired URL just renders as a blank box.
//
// Put the returned handler on the `onError` of the <img>/<video>: it fetches fresh URLs through
// `refresh`. At most once a minute, so an object that is really gone - where the new URL fails too -
// costs one refetch rather than a loop.
const MIN_INTERVAL_MS = 60 * 1000;

export function useMediaErrorRefresh(refresh: () => void) {
  const refreshRef = useRef(refresh);
  useEffect(() => { refreshRef.current = refresh; }, [refresh]);
  const lastRefresh = useRef(0);

  return useCallback(() => {
    const now = Date.now();
    if (now - lastRefresh.current < MIN_INTERVAL_MS) return;
    lastRefresh.current = now;
    refreshRef.current();
  }, []);
}
